module.exports = __webpack_public_path__ + "static/media/instagram-icon-newpurple.1c00352f.svg";